import React, { Component } from "react";
import jcaeGif from './jcae2022_paper.gif'; // Import the GIF file

export default class ProgrammingLanguagesImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div>
        <img src={jcaeGif} alt="JCAE paper"/>
      </div>
    );
  }
}
